import type { CurrencyType, SocialLinkType } from "@/types";
// Added 'Youtube', removed unused icons if necessary
import { Youtube, Instagram } from "lucide-vue-next";
import DiscordIcon from "@/assets/icons/DiscordIcon.vue";
import TiktokIcon from "@/assets/icons/tiktokIcon.vue";

export const appName: string = "TicketForge";
export const appTitle: string =
  "TicketForge - Discord Ticketing Bot";
export const appDescription: string =
  "TicketForge brings a robust ticketing Bot to your Discord server. Use our bot and intuitive web dashboard to easily manage support requests, assign tickets, track progress, and provide faster, organized help to your community.";
export const appAuthor: string = "Evolvex";
export const appAuthorWebsite: string = "https://discord.gg/7xaUsPqWAg";
export const discordInviteLinkForServers: string =
  "https://discord.com/oauth2/authorize?client_id=1312832688889008218&permissions=2252160926870544&integration_type=0&scope=applications.commands+bot";
export const upTimeStatusUrl: string = "https://ticketforge.statuspage.io/";
export const buyLink: string = "";
export const docsUrl: string = "https://docs.ticketforge.xyz/";

// Defined the YouTube link
export const youtubeLink: string = "https://youtu.be/Im3quAqKLSI";

export const currentYear: number = new Date().getFullYear();

export const currency: CurrencyType = "€";

export const socialLinks: SocialLinkType[] = [
  {
    name: "Discord",
    icon: DiscordIcon,
    route: { url: "https://discord.gg/7xaUsPqWAg" },
  },
  {
    name: "YouTube",
    icon: Youtube, // Uses the Lucide icon
    route: { url: "https://www.youtube.com/@TicketForge" },
  },
  {
    name: "TikTok",
    icon: TiktokIcon, // Uses the Lucide icon
    route: { url: "https://www.tiktok.com/@ticketforge" },
  },
  {
    name: "Instagram",
    icon: Instagram, // Uses the Lucide icon
    route: { url: "https://www.instagram.com/ticketforge/" },
  },
];
